import { logError } from "~/shared/services/error-reporting";

export function capitalizeFirstLetter(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

interface ButtonCopyArrayToClipboardProps {
  arrayToCopy: string[];
  delimiter?: string;
  onDone?: (content: string) => void;
  onError?: () => void;
}

export const copyToClipboard = async ({
  arrayToCopy,
  onDone,
  onError,
  delimiter = "; ",
}: ButtonCopyArrayToClipboardProps) => {
  const textToCopy = arrayToCopy.join(delimiter);
  try {
    await navigator.clipboard.writeText(textToCopy);
    onDone?.(textToCopy);
  } catch (err) {
    logError(err);
    onError?.();
  }
};

export const isNonNegativeInteger = (
  value: number | undefined,
): value is number =>
  value !== undefined && Number.isInteger(value) && value >= 0;

export const downloadFile = (url: string, name = "") => {
  const a = document.createElement("a");
  a.href = url;
  a.download = name;

  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};
